import React from 'react';
export default props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13px"
    height="16px"
    viewBox="0 0 11 6"
    style={{ fill: '#7b7f83', transform: props.isLeft ? 'rotate(180deg)' : '' }}
  >
    <polygon
      fillRule="evenodd"
      points="249.667 9.303 246.925 12.045 246.925 9.772 239.485 9.772 239.485 8.833 246.925 8.833 246.925 6.561"
      transform="translate(-239 -6)"
    />
  </svg>
);
